export default {"src":"/_next/static/media/bot_icon.9023de98.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};